import axios from 'axios';

import { API_BASE_URL } from './config';

export function getApiKeyBootstrap(locationHref) {
  const url = new URL(locationHref);
  const apiKey = url.searchParams.get('apiKey')?.trim();

  if (!apiKey) {
    return null;
  }

  url.searchParams.delete('apiKey');

  return {
    apiKey,
    sanitizedPath: `${url.pathname}${url.search}${url.hash}`,
  };
}

export async function bootstrapApiKeyAuth({ location = window.location, history = window.history, client = axios } = {}) {
  const auth = getApiKeyBootstrap(location.href);

  if (!auth) {
    return;
  }

  history.replaceState(history.state, '', auth.sanitizedPath);

  try {
    await client.post(
      `${API_BASE_URL}/accounts/@login/api-key`,
      { apiKey: auth.apiKey },
      { withCredentials: true }
    );
  } catch (_error) {
    return;
  }
}
